/* COBE product template (templates/product.cobe.json): behaviour shared by the COBE blocks.
   Loaded by snippets/cobe-pdp-head.liquid when the main-product section has "COBE design" on. */
(function () {
  'use strict';

  /* The thumbnail column is vertical on desktop; Dawn only scrolls it horizontally.
     Keep the active thumbnail in view. */
  function revealThumb(item) {
    var list = item && item.closest('.thumbnail-list');
    if (!list || window.innerWidth < 990) return;
    var top = item.offsetTop;
    var bottom = top + item.offsetHeight;
    if (top < list.scrollTop) list.scrollTo({ top: top, behavior: 'smooth' });
    else if (bottom > list.scrollTop + list.clientHeight) list.scrollTo({ top: bottom - list.clientHeight, behavior: 'smooth' });
  }
  document.addEventListener('click', function (e) {
    var item = e.target.closest && e.target.closest('.thumbnail-list__item');
    if (item) revealThumb(item);
  });
  new MutationObserver(function (records) {
    records.forEach(function (r) {
      if (r.target.getAttribute('aria-current') === 'true') revealThumb(r.target.closest('.thumbnail-list__item'));
    });
  }).observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });

  /* Smooth <details> accordions (product tabs, FAQ): animate the content height with
     the Web Animations API instead of the native jump. */
  function animateDetails(details, content, summary) {
    if (!details || !content || details.dataset.cobeAnimating) return;
    summary.addEventListener('click', function (e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      if (details.dataset.cobeAnimating) return;
      details.dataset.cobeAnimating = '1';
      var closing = details.open;
      if (!closing) details.open = true;
      /* The content has 8px/38.7px vertical padding: with the default content-box
         a height animation stops at the padding height and the panel visibly
         sticks before snapping shut. Animate in border-box and collapse the
         paddings together with the height. */
      var cs = getComputedStyle(content);
      var padTop = cs.paddingTop, padBottom = cs.paddingBottom;
      var full = content.offsetHeight;
      var from = closing ? full : 0;
      var to = closing ? 0 : full;
      content.style.boxSizing = 'border-box';
      content.style.height = from + 'px';
      content.style.overflow = 'hidden';
      var anim = content.animate([
        { height: from + 'px', opacity: closing ? 1 : 0, paddingTop: closing ? padTop : '0px', paddingBottom: closing ? padBottom : '0px' },
        { height: to + 'px', opacity: closing ? 0 : 1, paddingTop: closing ? '0px' : padTop, paddingBottom: closing ? '0px' : padBottom }
      ], { duration: 280, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' });
      var done = false;
      var cleanup = function () {
        if (done) return;
        done = true;
        content.style.height = '';
        content.style.overflow = '';
        content.style.boxSizing = '';
        if (closing) details.open = false;
        delete details.dataset.cobeAnimating;
      };
      anim.onfinish = anim.oncancel = cleanup;
      /* if the animation never reports back (suspended tab, devtools pause), the
         accordion must not stay locked */
      setTimeout(cleanup, 450);
    });
  }
  function initAccordions(scope) {
    (scope || document).querySelectorAll('.product__accordion details, details.cobe-faq__item').forEach(function (d) {
      if (d.dataset.cobeAccordion) return;
      d.dataset.cobeAccordion = '1';
      var summary = d.querySelector('summary');
      var content = d.querySelector('.accordion__content, .cobe-faq__answer');
      if (summary && content) animateDetails(d, content, summary);
    });
  }
  initAccordions();
  document.addEventListener('shopify:section:load', function (e) { initAccordions(e.target); });

  /* Rating row under the title: opens the reviews modal (via the reviews strip's
     own opener so the Loox resize handling runs too); scrolling to the strip is
     only the fallback when the modal is not on the page. */
  function initRatingLink() {
    var row = document.querySelector('[id^="MainProduct-"] .rating-wrapper');
    if (!row || row.dataset.cobeReady) return;
    var opener = document.querySelector('[data-cobe-reviews-open]');
    var target = document.querySelector('.cobe-reviews') || document.querySelector('#looxReviews');
    if (!opener && !target) return;
    row.dataset.cobeReady = '1';
    row.setAttribute('role', 'button');
    row.setAttribute('tabindex', '0');
    row.setAttribute('aria-label', (row.textContent || '').replace(/\s+/g, ' ').trim() + ' - read reviews');
    var go = function () {
      if (opener) opener.click();
      else target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    row.addEventListener('click', go);
    row.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
  }
  initRatingLink();
  document.addEventListener('shopify:section:load', initRatingLink);

  /* Mobile: the size-guide link moved above the size select, as in the Figma mobile frame. */
  var mobileMq = window.matchMedia('(max-width: 749px)');
  function placeSizeGuide() {
    var section = document.querySelector('[id^="MainProduct-"]');
    if (!section) return;
    var guide = section.querySelector('.cobe-size-guide');
    var picker = section.querySelector('variant-selects');
    if (!guide || !picker) return;
    if (mobileMq.matches) {
      if (guide.nextElementSibling !== picker) picker.insertAdjacentElement('beforebegin', guide);
    } else if (guide.previousElementSibling !== picker) {
      picker.insertAdjacentElement('afterend', guide);
    }
  }
  placeSizeGuide();
  mobileMq.addEventListener('change', placeSizeGuide);
  document.addEventListener('shopify:section:load', placeSizeGuide);

  /* Delivery estimate block: today + N working days (Monday to Saturday, minus the
     bank holidays listed in the block settings). Config comes from data attributes. */
  function isoDate(d) { return d.toISOString().split('T')[0]; }
  function addWorkingDays(start, days, holidays) {
    var date = new Date(start);
    var added = 0;
    while (added < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() !== 0 && holidays.indexOf(isoDate(date)) === -1) added++;
    }
    return date;
  }
  function formatDate(d) { return d.toLocaleString('en-GB', { month: 'short', day: 'numeric' }); }
  function renderDelivery(root) {
    var out = root.querySelector('[data-cobe-delivery-dates]');
    if (!out) return;
    var holidays = (root.dataset.holidays || '').split(/[\s,]+/).filter(Boolean);
    var today = new Date();
    var from = addWorkingDays(today, parseInt(root.dataset.minDays, 10) || 3, holidays);
    var to = addWorkingDays(today, parseInt(root.dataset.maxDays, 10) || 5, holidays);
    out.textContent = formatDate(from) + ' - ' + formatDate(to);
  }
  function initDelivery(scope) {
    (scope || document).querySelectorAll('[data-cobe-delivery]').forEach(renderDelivery);
  }
  initDelivery();
  /* The theme editor re-renders the section when a setting changes */
  document.addEventListener('shopify:section:load', function (e) { initDelivery(e.target); });
  /* Hide the delivery estimate and the 48-hour promises ([data-cobe-hide-preorder]) while the selected size is a pre-order variant.
     Liquid sets the initial state (no flash); Dawn does not re-render this block on
     variant change, so the selected <option>'s data-hide-delivery (pre-order or selling
     plan, printed by product-variant-options.liquid) is read on every DOM change.
     ?cobe_preorder_debug=1 treats sold-out sizes as pre-order, off the live theme only. */
  function initDeliveryVisibility() {
    var section = document.querySelector('[id^="MainProduct-"]');
    if (!section || section.dataset.cobeDeliveryVis) return;
    section.dataset.cobeDeliveryVis = '1';
    var debug = /[?&]cobe_preorder_debug=1(&|$)/.test(location.search);
    var apply = function () {
      var boxes = section.querySelectorAll('[data-cobe-hide-preorder]');
      var option = section.querySelector('variant-selects select option:checked');
      if (!boxes.length || !option) return;
      var hide = option.hasAttribute('data-hide-delivery') || (debug && option.hasAttribute('data-preorder-debug'));
      Array.prototype.forEach.call(boxes, function (box) {
        if (box.hidden !== hide) box.hidden = hide;
      });
    };
    apply();
    /* childList only: toggling [hidden] is an attribute change and cannot re-trigger this */
    new MutationObserver(apply).observe(section, { childList: true, subtree: true });
    section.addEventListener('change', apply);
  }
  initDeliveryVisibility();
  document.addEventListener('shopify:section:load', initDeliveryVisibility);
  /* ---- Sticky add-to-cart bar ------------------------------------------
     Shows once the main Add to cart button is above the viewport, hides
     near the footer. Mirrors #price-<section id> (price + SAVE badge) and
     the main button's label/disabled state; clicks are forwarded to the
     main Add to cart and wishlist buttons so app flows stay intact. */
  function initStickyAtc() {
    var bar = document.querySelector('[data-cobe-sticky]');
    if (!bar || bar.dataset.cobeInit) return;
    bar.dataset.cobeInit = '1';
    var sectionId = bar.dataset.section;
    var mainBtn = document.getElementById('ProductSubmitButton-' + sectionId);
    var priceBox = document.getElementById('price-' + sectionId);
    var mainWish = document.querySelector('[id^="MainProduct-"] .nm-PRODUCT_PAGE-wishlist-button');
    var footer = document.querySelector('.footer') || document.querySelector('[id$="__footer"]');
    var btn = bar.querySelector('[data-cobe-sticky-atc]');
    var label = btn && btn.querySelector('span');
    var priceSlot = bar.querySelector('[data-cobe-sticky-price]');
    var wish = bar.querySelector('[data-cobe-sticky-wish]');
    var img = bar.querySelector('.cobe-sticky__img');
    var root = document.documentElement;
    var lift = bar.dataset.liftWidgets === 'true';
    if (!mainBtn || !btn) return;

    /* price mirror: Dawn re-renders #price-<id> on every variant change */
    function syncPrice() {
      if (priceBox && priceSlot) {
        priceSlot.innerHTML = priceBox.innerHTML;
        /* the full pre-order badge text does not fit the bar: keep the phrase before the dash */
        var badge = priceSlot.querySelector('.hengam-preorder-badge');
        if (badge) {
          var short = badge.textContent.split(/[—–]/)[0].trim();
          if (short) badge.textContent = short;
        }
      }
    }
    if (priceBox) new MutationObserver(syncPrice).observe(priceBox, { childList: true, subtree: true });
    syncPrice();

    /* button mirror: label (unless overridden) + disabled state */
    function syncButton() {
      btn.disabled = mainBtn.disabled;
      btn.classList.toggle('loading', mainBtn.classList.contains('loading'));
      if (!bar.dataset.label && label) {
        var span = mainBtn.querySelector('span');
        var text = (span ? span.textContent : mainBtn.textContent).trim();
        if (text) label.textContent = text;
      }
    }
    new MutationObserver(syncButton).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    syncButton();
    btn.addEventListener('click', function () { mainBtn.click(); });

    /* wishlist proxy: forwards the click, mirrors the app's icon/state. The
       app injects its button after page load, so wait for it (up to 15s). */
    if (wish) {
      var wireWish = function (target) {
        /* icon mirror only; the in-wishlist state is driven by syncWishState()
           from localStorage, because the app never flags its own button */
        var syncWish = function () {
          var icon = target.querySelector('svg');
          if (icon) { wish.innerHTML = ''; wish.appendChild(icon.cloneNode(true)); }
        };
        new MutationObserver(syncWish).observe(target, { attributes: true, childList: true, subtree: true });
        syncWish();
        wish.addEventListener('click', function () { target.click(); });
        wish.hidden = false;
      };
      if (mainWish) {
        wireWish(mainWish);
      } else {
        wish.hidden = true;
        var tries = 0;
        var poll = setInterval(function () {
          var found = document.querySelector('[id^="MainProduct-"] .nm-PRODUCT_PAGE-wishlist-button');
          if (found) { clearInterval(poll); wireWish(found); }
          else if (++tries > 30) { clearInterval(poll); }
        }, 500);
      }
    }

    /* variant image */
    if (img && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        var src = v && ((v.featured_media && v.featured_media.preview_image && v.featured_media.preview_image.src) || (v.featured_image && v.featured_image.src));
        if (!src) return;
        try {
          var u = new URL(src, location.origin);
          u.searchParams.set('width', '120');
          img.removeAttribute('srcset');
          img.src = u.href;
        } catch (e) { /* keep the current image */ }
      });
    }

    /* visibility */
    var pastButton = false, nearFooter = false, forced = false;
    function update() {
      var show = forced || (pastButton && !nearFooter);
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (lift) root.classList.toggle('cobe-sticky-visible', show);
    }
    function setHeight() { root.style.setProperty('--cobe-sticky-h', Math.round(bar.getBoundingClientRect().height) + 'px'); }
    if (typeof ResizeObserver === 'function') new ResizeObserver(setHeight).observe(bar);
    setHeight();
    /* scroll-driven (rAF-throttled) rather than IntersectionObserver: a jump
       from below the button to above it (fling, anchor, back-forward cache)
       never crosses an intersection threshold, so IO would miss it */
    var offset = parseInt(bar.dataset.footerOffset, 10) || 0;
    var ticking = false;
    function check() {
      ticking = false;
      pastButton = mainBtn.getBoundingClientRect().bottom < 0;
      nearFooter = footer ? footer.getBoundingClientRect().top < window.innerHeight + offset : false;
      update();
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    check();
    /* theme editor: keep the bar on screen while its block is selected */
    document.addEventListener('shopify:block:select', function (e) { if (e.target === bar) { forced = true; update(); } });
    document.addEventListener('shopify:block:deselect', function (e) { if (e.target === bar) { forced = false; update(); } });
  }
  initStickyAtc();
  document.addEventListener('shopify:section:load', initStickyAtc);

  /* Notify Me's button selector misses the main form button, so a pre-order
     variant still reads "Add to cart". The app's pre-order price block in the
     price box is the reliable signal: while it is rendered, relabel the button
     to "Pre-Order Now" and reveal the dispatch note (cobe_preorder_note block,
     editable text, default "Mid October dispatch") under it. The sticky bar
     mirrors the button label on its own (initStickyAtc's syncButton). */
  function initPreorderLabel() {
    var section = document.querySelector('[id^="MainProduct-"]');
    if (!section || section.dataset.cobePreorderLabel) return;
    var priceBox = section.querySelector('[id^="price-"]');
    var btn = section.querySelector('.product-form__submit');
    if (!priceBox || !btn) return;
    section.dataset.cobePreorderLabel = '1';
    var defaultLabel = null;
    var preorderLabel = 'Pre-Order Now';
    var note = section.querySelector('[data-cobe-preorder-note]');
    /* the note block renders after the whole buy-buttons block; move it into the
       button row so it sits centred directly under Add to cart (grid row 2) */
    var row = section.querySelector('.product-form__buttons');
    if (note && row && note.parentNode !== row) row.appendChild(note);
    var apply = function () {
      /* one badge row: SAVE (yellow) sits left of the pre-order pill. The app
         rebuilds its wrapper's content on every refresh, so a node moved into
         it gets destroyed - keep Dawn's original hidden in place and maintain
         a clone inside the wrapper instead (re-inserted after each wipe). */
      var wrap = priceBox.querySelector('.hengam-product-price-wrapper');
      var original = priceBox.querySelector('.cobe-save-badge:not([data-cobe-clone])');
      if (wrap) {
        if (original) {
          original.style.display = 'none';
          if (!wrap.querySelector('.cobe-save-badge')) {
            var clone = original.cloneNode(true);
            clone.setAttribute('data-cobe-clone', '1');
            clone.style.display = '';
            wrap.insertBefore(clone, wrap.querySelector('.hengam-preorder-badge'));
          }
        }
      } else if (original) {
        original.style.display = '';
      }
      var span = btn.querySelector('span');
      if (!span) return;
      /* Decide from the selected variant's own option (data-preorder is printed by
         product-variant-options.liquid and follows the select at once). The app's
         price block lags behind a variant change, so it is only the fallback when no
         dropdown option is present. */
      var opt = section.querySelector('variant-selects select option:checked');
      var pre = opt ? opt.hasAttribute('data-preorder') : !!wrap;
      var txt = span.textContent.trim();
      /* Notify Me writes its own offer label (admin "button text", e.g. "Pre-Order Now -
         Dispatch Mid October") into the button on every variant change while the URL still
         names the previous pre-order variant. Dawn keeps the button disabled during its
         section fetch, so on a slow connection that label stayed visible for seconds.
         Replace it whatever the disabled state. */
      var appLabel = txt !== preorderLabel && /^pre-?order/i.test(txt);
      if (pre) {
        if ((!btn.disabled || appLabel) && txt !== preorderLabel) {
          if (txt && !appLabel) defaultLabel = txt;
          span.textContent = preorderLabel;
        }
        if (note) note.hidden = false;
      } else {
        if (txt === preorderLabel || appLabel) {
          /* the app removes its price block asynchronously, after Dawn has already
             reset the label - so the label must be restored here as well */
          span.textContent = (window.variantStrings && window.variantStrings.addToCart) || defaultLabel || 'Add to cart';
        }
        if (note) note.hidden = true;
      }
    };
    new MutationObserver(apply).observe(priceBox, { childList: true, subtree: true });
    new MutationObserver(apply).observe(btn, { childList: true, subtree: true, characterData: true });
    apply();

    /* The row renders in stages (Dawn first, the app's pre-order block after):
       keep it invisible while mutations are still coming and fade everything in
       at once after a quiet beat. The cap guarantees it never stays hidden. */
    var settleQuiet = null, settleCap = null;
    var reveal = function () {
      clearTimeout(settleQuiet);
      clearTimeout(settleCap);
      settleQuiet = settleCap = null;
      priceBox.classList.remove('cobe-price-settling');
    };
    new MutationObserver(function () {
      /* the app's pre-order block lands ~350ms after Dawn's render: the quiet
         window must outlast that gap or the row fades in twice */
      if (!settleCap) settleCap = setTimeout(reveal, 1200);
      priceBox.classList.add('cobe-price-settling');
      clearTimeout(settleQuiet);
      settleQuiet = setTimeout(reveal, 400);
    }).observe(priceBox, { childList: true, subtree: true });
  }
  initPreorderLabel();
  document.addEventListener('shopify:section:load', initPreorderLabel);

  /* Size dropdown: show the height range next to each size value (client ask,
     sizing clarity). The mapping is an editable setting on the cobe_size_guide
     block (data-dropdown-heights on #sg-open-btn, format "Size:range|Size:range",
     the Size value must match the option value exactly). Only the <option>'s
     visible text changes - the value attribute, which Dawn's variant-selects
     reads to pick the variant, is left untouched. Dawn re-renders variant-selects
     from the server on every variant change (product-info updateOptionValues),
     which drops the ranges again, so they are re-applied on DOM mutations. */
  function initSizeDropdownHeights() {
    var section = document.querySelector('[id^="MainProduct-"]');
    var trigger = document.getElementById('sg-open-btn');
    var raw = trigger && trigger.dataset.dropdownHeights;
    if (!section || !raw || section.dataset.cobeSizeHeights) return;
    section.dataset.cobeSizeHeights = '1';
    var map = {};
    raw.split('|').forEach(function (pair) {
      var i = pair.indexOf(':');
      if (i === -1) return;
      var key = pair.slice(0, i).trim().toLowerCase();
      var range = pair.slice(i + 1).trim();
      if (key && range) map[key] = range;
    });
    var preorderDebug = /[?&]cobe_preorder_debug=1(&|$)/.test(location.search);
    var apply = function () {
      var select = section.querySelector('variant-selects select[name="options[Size]"]') ||
        section.querySelector('variant-selects select.select__select');
      if (!select) return;
      Array.prototype.forEach.call(select.querySelectorAll('option'), function (option) {
        var value = (option.value || '').trim();
        /* Preview only (Liquid prints data-preorder-debug off the live theme):
           ?cobe_preorder_debug=1 shows "(Pre-order)" on sold-out sizes. Real
           pre-order sizes already carry the suffix from Liquid (data-preorder),
           and the range logic below keeps it after the height range. */
        if (preorderDebug && option.hasAttribute('data-preorder-debug') && option.textContent.indexOf('(Pre-order)') === -1) {
          option.textContent = value + ' (Pre-order)';
        }
        var range = map[value.toLowerCase()];
        if (!range || option.textContent.indexOf(range) !== -1) return;
        var text = option.textContent.trim();
        /* keep Dawn's own suffixes ("Small - Sold out") after the range */
        option.textContent = text.indexOf(value) === 0 ? value + ' (' + range + ')' + text.slice(value.length) : text + ' (' + range + ')';
      });
    };
    apply();
    new MutationObserver(apply).observe(section, { childList: true, subtree: true });
  }
  initSizeDropdownHeights();
  document.addEventListener('shopify:section:load', initSizeDropdownHeights);

  /* Dawn's media-gallery scrolls the PAGE to the variant image after a variant
     switch (media-gallery.js window.scrollTo inside setActiveMedia) - on mobile
     that yanks the user from the buy box to the top. Keep the slider's own
     horizontal scroll, swallow only the window scroll for that tick.
     Counted, so overlapping mutes (variant switch + thumbnail tap) always
     restore the real window.scrollTo. */
  var muteDepth = 0, realWindowScrollTo = null;
  function muteWindowScroll(ms) {
    if (!muteDepth++) { realWindowScrollTo = window.scrollTo; window.scrollTo = function () {}; }
    setTimeout(function () { if (!--muteDepth) window.scrollTo = realWindowScrollTo; }, ms);
  }
  function initNoJumpOnVariant() {
    var mg = document.querySelector('[id^="MainProduct-"] media-gallery');
    if (!mg || mg.dataset.cobeNoJump || typeof mg.setActiveMedia !== 'function') return;
    mg.dataset.cobeNoJump = '1';
    var orig = mg.setActiveMedia.bind(mg);
    mg.setActiveMedia = function () {
      muteWindowScroll(80);
      orig.apply(null, arguments);
    };
  }
  initNoJumpOnVariant();

  /* Thumbnail taps. (1) The same page jump: Dawn binds the thumbnail click
     listeners to the ORIGINAL setActiveMedia in its constructor, so the wrapper
     above never sees them. With the image even slightly above the viewport every
     tap scrolled the page up to the image top - on mobile the thumbnail row slid
     away under the finger and the next tap landed on the image (zoom) instead.
     (2) Dawn moves the active ring only through a 500ms debounce after the slider
     stops, so after a swipe the ring trailed the photo. Follow the slider at once,
     except while a tap-driven scroll is still passing the slides in between. */
  function initThumbTaps() {
    var mg = document.querySelector('[id^="MainProduct-"] media-gallery');
    var thumbs = mg && mg.querySelector('[id^="GalleryThumbnails-"]');
    var viewer = mg && mg.querySelector('[id^="GalleryViewer-"]');
    if (!thumbs || !viewer || mg.dataset.cobeThumbTaps || typeof mg.setActiveThumbnail !== 'function') return;
    mg.dataset.cobeThumbTaps = '1';
    var tapTarget = null, tapTimer = null;
    thumbs.addEventListener('click', function (e) {
      var item = e.target.closest && e.target.closest('[data-target]');
      if (!item || !e.target.closest('button')) return;
      muteWindowScroll(80);
      tapTarget = item.dataset.target;
      clearTimeout(tapTimer);
      tapTimer = setTimeout(function () { tapTarget = null; }, 2000);
    }, true);
    viewer.addEventListener('touchstart', function () { tapTarget = null; }, { passive: true });
    viewer.addEventListener('slideChanged', function (e) {
      var slide = e.detail && e.detail.currentElement;
      if (!slide) return;
      if (tapTarget) { if (slide.dataset.mediaId === tapTarget) tapTarget = null; return; }
      var thumb = thumbs.querySelector('[data-target="' + slide.dataset.mediaId + '"]');
      if (thumb) mg.setActiveThumbnail(thumb);
    });
  }
  initThumbTaps();
  /* the custom element may register after this script runs */
  function initGalleryPatches() { initNoJumpOnVariant(); initThumbTaps(); }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(function () { setTimeout(initGalleryPatches, 0); }).catch(function () {});
  }
  setTimeout(initGalleryPatches, 1500);
  document.addEventListener('shopify:section:load', initGalleryPatches);

  /* Desktop thumbnail column: drag-to-scroll with the mouse (wheel already works). */
  function initThumbDrag() {
    var list = document.querySelector('[id^="MainProduct-"] .thumbnail-slider .thumbnail-list');
    if (!list || list.dataset.cobeDrag) return;
    list.dataset.cobeDrag = '1';
    var startY = 0, startTop = 0, active = false, moved = false;
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      active = true; moved = false;
      startY = e.clientY; startTop = list.scrollTop;
      list.classList.add('cobe-dragging');
    });
    window.addEventListener('pointermove', function (e) {
      if (!active) return;
      var dy = e.clientY - startY;
      if (!moved && Math.abs(dy) > 4) moved = true;
      if (moved) list.scrollTop = startTop - dy;
    });
    window.addEventListener('pointerup', function () { active = false; list.classList.remove('cobe-dragging'); });
    window.addEventListener('pointercancel', function () { active = false; list.classList.remove('cobe-dragging'); });
    /* a drag must not fire the thumbnail click it ends on */
    list.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  initThumbDrag();
  document.addEventListener('shopify:section:load', initThumbDrag);
  /* Gallery size filter. Media whose alt text carries a token like "[sizes: XS, S, M]" (also
     "[size: L]", case-insensitive) are shown only for those sizes; media without a token show for
     every variant; if nothing would be left, everything is shown. The server (snippets/
     cobe-media-sizes.liquid) renders the initial state as data-sizes="xs,s,m" plus the class
     is-hidden-for-size; here the class is toggled on a variant change, with no re-render. The same
     rule and table live in Liquid (snippets/cobe-size-match.liquid), keep both in step: a token is
     the exact variant name or XS, S, M, L, XL, XXL. The Size option position comes from
     data-size-index on the media-gallery element.

     Active slide after a change: Dawn jumps to the variant's featured image (and moves it to the
     front) every time, which would throw the shopper off the photo they are looking at. So the
     slide in view just BEFORE that jump is remembered (mg.cobePrevMedia, see
     rememberMediaBeforeJump), and afterwards:
       1. the remembered slide, if it is still visible;
       2. else its partner: tagged images come in pairs, the original followed by its copy for
          the other sizes, so inside a run of consecutive tagged slides the slide at an even
          position pairs with the next one and the slide at an odd position with the previous one;
       3. else the variant's own featured image if it is size-tagged and visible (Dawn's jump);
       4. else the next visible slide after it (the first visible one when none follows). */
  var SIZE_FORMS = { s: ['small'], m: ['medium'], l: ['large'], xl: ['xl', 'x-large'], xxl: ['xxl', 'xx-large', '2xl'] };
  function sizeMatches(list, size) {
    return list.split(',').some(function (token) {
      return (SIZE_FORMS[token] || [token]).some(function (form) { return size.indexOf(form) === 0; });
    });
  }
  function isTagged(el) { return !!el.getAttribute('data-sizes'); }
  function isShown(el) { return !el.classList.contains('is-hidden-for-size'); }
  function pickAfterFilter(slides, prevId, featuredId) {
    var byId = function (id) { return slides.filter(function (el) { return el.dataset.mediaId === id; })[0]; };
    var featured = byId(featuredId);
    var prev = byId(prevId);
    if (!prev) return (featured && isShown(featured) ? featured : null) || slides.filter(isShown)[0];
    if (isShown(prev)) return prev;
    var i = slides.indexOf(prev), start = i;
    while (start > 0 && isTagged(slides[start - 1])) start--;
    if (isTagged(prev)) {
      var partner = slides[(i - start) % 2 === 0 ? i + 1 : i - 1];
      if (partner && isTagged(partner) && isShown(partner)) return partner;
    }
    if (featured && isTagged(featured) && isShown(featured)) return featured;
    return slides.slice(i + 1).filter(isShown)[0] || slides.filter(isShown)[0];
  }
  function applySizeFilter(mg, modal, size, featuredId) {
    var viewer = mg.querySelector('[id^="GalleryViewer-"]');
    var thumbs = mg.querySelector('[id^="GalleryThumbnails-"]');
    var nodes = [].concat(
      viewer ? [].slice.call(viewer.querySelectorAll('li[data-sizes]')) : [],
      thumbs ? [].slice.call(thumbs.querySelectorAll('li[data-sizes]')) : [],
      modal ? [].slice.call(modal.querySelectorAll('img[data-sizes]')) : []
    );
    var matches = function (el) {
      var list = el.getAttribute('data-sizes');
      return !list || !size || sizeMatches(list, size);
    };
    var showAll = !nodes.some(function (el) { return matches(el); });
    nodes.forEach(function (el) { el.classList.toggle('is-hidden-for-size', !showAll && !matches(el)); });
    var slides = viewer ? [].slice.call(viewer.querySelectorAll('li[data-media-id]')) : [];
    var active = slides.filter(function (el) { return el.classList.contains('is-active'); })[0];
    var target = pickAfterFilter(slides, mg.cobePrevMedia, featuredId);
    /* re-measure Dawn's sliders instead of re-initialising them */
    [viewer, thumbs].forEach(function (slider) { if (slider && typeof slider.resetPages === 'function') slider.resetPages(); });
    if (target && target !== active && typeof mg.setActiveMedia === 'function') {
      mg.cobeOwnCall = true;
      mg.setActiveMedia(target.dataset.mediaId, false);
      mg.cobeOwnCall = false;
    }
  }
  /* The slide in view right before Dawn's jump. Wrapping setActiveMedia is the reliable source:
     Dawn's updateMedia calls it (through the element) before it publishes variantChange, and at
     that moment the thumbnail ring (aria-current, kept in step with swipes by initThumbTaps and
     with taps by Dawn) still points at the shopper's slide. A MutationObserver on the is-active
     class would be wrong: is-active only changes through setActiveMedia, so a swipe never updates
     it, and it would already show the jump target by the time the event arrives. */
  function rememberMediaBeforeJump(mg) {
    if (mg.cobeSizeWrapped || typeof mg.setActiveMedia !== 'function') return;
    mg.cobeSizeWrapped = true;
    var orig = mg.setActiveMedia;
    mg.setActiveMedia = function () {
      if (!mg.cobeOwnCall) {
        var ring = mg.querySelector('[id^="GalleryThumbnails-"] [aria-current="true"]');
        var item = ring && ring.closest('[data-target]');
        var slide = mg.querySelector('[id^="GalleryViewer-"] li.is-active');
        mg.cobePrevMedia = item ? item.dataset.target : (slide ? slide.dataset.mediaId : null);
      }
      return orig.apply(mg, arguments);
    };
  }
  /* Elements are looked up on every change, a section reload replaces them. */
  function onSizeVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.sectionId) return;
    var mg = document.getElementById('MediaGallery-' + data.sectionId);
    if (!mg || !mg.hasAttribute('data-size-index')) return;
    var index = parseInt(mg.dataset.sizeIndex, 10);
    if (isNaN(index) || index < 0) return;
    var value = data.variant && data.variant.options && data.variant.options[index];
    var featured = data.variant && data.variant.featured_media;
    applySizeFilter(mg, document.getElementById('ProductModal-' + data.sectionId), value ? String(value).replace(/\s+/g, '').toLowerCase() : '',
      featured ? data.sectionId + '-' + featured.id : null);
  }
  function initSizeFilter() {
    if (!window.cobeSizeFilterBound && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.cobeSizeFilterBound = true;
      subscribe(PUB_SUB_EVENTS.variantChange, onSizeVariantChange);
    }
    /* the server may render the variant's own image first although it is hidden for its size */
    var mg = document.querySelector('[id^="MainProduct-"] media-gallery[data-size-index]');
    if (mg) rememberMediaBeforeJump(mg);
    var hidden = mg && mg.querySelector('[id^="GalleryViewer-"] li.is-active.is-hidden-for-size');
    if (!hidden || typeof mg.setActiveMedia !== 'function') return;
    var hit = mg.querySelector('[id^="GalleryViewer-"] li[data-media-id]:not(.is-hidden-for-size)');
    if (hit) mg.setActiveMedia(hit.dataset.mediaId, false);
  }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('media-gallery').then(function () { setTimeout(initSizeFilter, 0); }).catch(function () {});
  }
  document.addEventListener('shopify:section:load', initSizeFilter);
  /* Notify Me placeholder. The app injects its back-in-stock button a moment after load; until
     then snippets/buy-buttons.liquid renders the buy row with cobe-await-nm (placeholder dots in
     the disabled button, aria-busy on the row). The class goes as soon as the app's button is in
     the row (CSS then swaps Sold out for it in the same frame), or after NM_WAIT_MS when the app
     never shows (blocked, not configured) so "Sold out" becomes visible. Variant changes re-run
     the same decision. */
  var NM_WAIT_MS = 2500, nmTimer = null, nmObserved = null;
  function nmRow() { return document.querySelector('[id^="MainProduct-"] .product-form__buttons'); }
  function nmHasButton(row) { return !!row.querySelector('.nm-portal > .restock-alerts-notify-button'); }
  function nmStop() {
    clearTimeout(nmTimer);
    var row = nmRow();
    if (!row) return;
    row.classList.remove('cobe-await-nm');
    row.removeAttribute('aria-busy');
  }
  function nmStart() {
    var row = nmRow();
    if (!row) return;
    if (nmHasButton(row)) return nmStop();
    row.classList.add('cobe-await-nm');
    row.setAttribute('aria-busy', 'true');
    clearTimeout(nmTimer);
    nmTimer = setTimeout(nmStop, NM_WAIT_MS);
  }
  function initNmWait() {
    var row = nmRow();
    if (!row) return;
    if (nmObserved !== row) {
      nmObserved = row;
      new MutationObserver(function () {
        if (row.classList.contains('cobe-await-nm') && nmHasButton(row)) nmStop();
      }).observe(row, { childList: true, subtree: true });
      if (row.classList.contains('cobe-await-nm')) {
        if (nmHasButton(row)) nmStop();
        else { clearTimeout(nmTimer); nmTimer = setTimeout(nmStop, NM_WAIT_MS); }
      }
    }
    if (!window.cobeNmWaitBound && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      window.cobeNmWaitBound = true;
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (variant && variant.available === false && variant.inventory_management) nmStart();
        else nmStop();
      });
    }
  }
  initNmWait();
  document.addEventListener('shopify:section:load', initNmWait);

  /* Desktop gallery swipe: Dawn only toggles .is-active on thumbnail clicks, so keep the class
     (used by the Bestseller badge) in step with the slide the visitor swiped to. */
  function initGallerySwipe() {
    var viewer = document.querySelector('[id^="MainProduct-"][id$="__main"] slider-component[id^="GalleryViewer-"]');
    if (!viewer || viewer.cobeSwipeBound) return;
    viewer.cobeSwipeBound = true;
    viewer.addEventListener('slideChanged', function (event) {
      var current = event && event.detail && event.detail.currentElement;
      if (!current || !window.matchMedia('(min-width: 990px)').matches) return;
      viewer.querySelectorAll('.product__media-item.is-active').forEach(function (el) { el.classList.remove('is-active'); });
      current.classList.add('is-active');
    });
  }
  initGallerySwipe();
  document.addEventListener('shopify:section:load', initGallerySwipe);

  /* Desktop mouse drag on the main gallery: press, drag, release moves one photo. Mouse pointers
     only (touch and pen keep the native swipe) and >= 990px. The list follows the cursor while
     dragging; the click that ends a drag is swallowed so it does not open the lightbox. */
  function initGalleryDrag() {
    var list = document.querySelector('[id^="MainProduct-"][id$="__main"] [id^="GalleryViewer-"] .product__media-list');
    if (!list || list.cobeDragBound) return;
    list.cobeDragBound = true;
    var desktop = window.matchMedia('(min-width: 990px)');
    var down = null;
    var dragging = false;
    var suppressClick = false;

    function restore() {
      list.style.scrollSnapType = '';
      list.style.scrollBehavior = '';
      list.style.cursor = '';
      list.classList.remove('is-dragging');
    }

    var lastX = 0;

    function onMove(e) {
      if (!down || e.pointerId !== down.id) return;
      lastX = e.clientX;
      var dx = e.clientX - down.x;
      if (!dragging) {
        if (Math.abs(dx) <= 8 || Math.abs(dx) < Math.abs(e.clientY - down.y)) return;
        dragging = true;
        list.classList.add('is-dragging');
        list.style.scrollSnapType = 'none';
        list.style.scrollBehavior = 'auto';
        try { list.setPointerCapture(e.pointerId); } catch (err) {}
      }
      list.scrollLeft = down.left - dx;
    }
    /* Bound on window for the length of one press, so a release outside the gallery (or outside
       the capture target) still ends the drag. */
    function finish(e) {
      if (!down || (e.pointerId !== undefined && e.pointerId !== down.id)) return;
      var wasDragging = dragging;
      var dx = (e.type === 'pointerup' ? e.clientX : lastX) - down.x;
      var width = list.clientWidth || 1;
      var base = Math.round(down.left / width);
      var fast = Date.now() - down.t < 300 && Math.abs(dx) > 25;
      var index = base;
      if (wasDragging && (Math.abs(dx) > 40 || fast)) index = base + (dx < 0 ? 1 : -1);
      var max = Math.round((list.scrollWidth - width) / width);
      index = Math.max(0, Math.min(max, index));
      var id = down.id;
      down = null;
      dragging = false;
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', finish);
      window.removeEventListener('pointercancel', finish);
      list.removeEventListener('lostpointercapture', finish);
      if (wasDragging) {
        suppressClick = true;
        setTimeout(function () { suppressClick = false; }, 0);
        try { list.releasePointerCapture(id); } catch (err) {}
        restore();
        list.scrollTo({ left: index * width, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
    }
    list.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0 || !desktop.matches) return;
      if (down) finish({ type: 'pointercancel', pointerId: down.id });
      down = { x: e.clientX, y: e.clientY, left: list.scrollLeft, t: Date.now(), id: e.pointerId };
      lastX = e.clientX;
      dragging = false;
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', finish);
      window.addEventListener('pointercancel', finish);
      list.addEventListener('lostpointercapture', finish);
    });
    list.addEventListener('click', function (e) {
      if (!suppressClick) return;
      e.preventDefault();
      e.stopPropagation();
    }, true);
    list.addEventListener('dragstart', function (e) { if (desktop.matches) e.preventDefault(); });
    /* Capture phase on window: also catches a native image/link drag that starts outside the list. */
    window.addEventListener('dragstart', function (e) { if (down) e.preventDefault(); }, true);
  }
  initGalleryDrag();
  document.addEventListener('shopify:section:load', initGalleryDrag);

  /* Gallery image warm-up: Dawn lazy-loads every main image after the first, so a swipe past the
     first slides shows a blank box while the WebP downloads. Load the first three slides eagerly
     and, on each slide change, prefetch two slides ahead (in the swipe direction) and one back. */
  function initGalleryPrefetch() {
    var viewer = document.querySelector('[id^="MainProduct-"][id$="__main"] slider-component[id^="GalleryViewer-"]');
    if (!viewer || viewer.cobePrefetchBound) return;
    var slides = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-list > li'));
    if (!slides.length) return;
    viewer.cobePrefetchBound = true;
    function mainImg(li) { return li && li.querySelector('img'); }
    function warm(li) {
      var img = mainImg(li);
      if (!img) return;
      img.loading = 'eager';
      if (!img.complete && !img.currentSrc) {
        var pre = new Image(); // same srcset and sizes, so the browser picks the identical candidate
        if (img.sizes) pre.sizes = img.sizes;
        if (img.srcset) pre.srcset = img.srcset;
        pre.src = img.getAttribute('src') || '';
      }
    }
    slides.slice(0, 3).forEach(function (li) { var img = mainImg(li); if (img) img.loading = 'eager'; });
    var first = mainImg(slides[0]);
    if (first && !first.getAttribute('fetchpriority')) first.setAttribute('fetchpriority', 'high');
    var last = 0;
    var lastFirst = slides[0];
    viewer.addEventListener('slideChanged', function (event) {
      // Dawn's product-info.js reorders the media li on a variant change, so read the list fresh each time
      var list = Array.prototype.slice.call(viewer.querySelectorAll('.product__media-list > li'));
      var current = event && event.detail && event.detail.currentElement;
      var index = list.indexOf(current);
      if (index < 0) return;
      if (list[0] !== lastFirst) { last = 0; lastFirst = list[0]; } // order changed: restart the direction counter
      var dir = index >= last ? 1 : -1;
      last = index;
      [index + dir, index + 2 * dir, index - dir].forEach(function (i) { warm(list[i]); });
    });
  }
  initGalleryPrefetch();
  document.addEventListener('shopify:section:load', initGalleryPrefetch);
})();
